import { Dialog, CircularProgress, Box } from '@mui/material';
//
// ################################################################################
//
const WaitingDialog = ({ open }) => {
  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: {
          backgroundColor: "transparent",
          boxShadow: "none",
          overflow: "visible",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "200px",
        }}
      >
        <CircularProgress
          thickness={4}
          size={50}
          sx={{ color: '#0D47A1' }}
        />
      </Box>
    </Dialog>
  );
};
export default WaitingDialog;
